import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button/Button';
import { BOM_DESCRIPTION_MAX_LENGTH } from 'constants/general';
import { BUTTON_VARIANT } from 'constants/interfaces';

import styles from './sass/BomDescriptionModal.module.scss';

interface IBomDescriptionModal {
  open: boolean,
  value: string,
  onSave: (value: string) => void,
  onClose: () => void,
}

function BomDescriptionModal({
  open, value, onSave, onClose,
}: IBomDescriptionModal) {
  const { t } = useTranslation();
  const [draft, setDraft] = useState(value);
  const normalizedDraft = draft.slice(0, BOM_DESCRIPTION_MAX_LENGTH);

  useEffect(() => {
    if (open) {
      setDraft(value.slice(0, BOM_DESCRIPTION_MAX_LENGTH));
    }
  }, [open, value]);

  if (!open) {
    return null;
  }

  return createPortal(
    <div
      className={styles.overlay}
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) {
          onClose();
        }
      }}
    >
      <div className={styles.modal}>
        <h3 className={styles.title}>{t('valueChainMap.bomUnitsDescription')}</h3>
        <textarea
          className={styles.textarea}
          value={normalizedDraft}
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
          maxLength={BOM_DESCRIPTION_MAX_LENGTH}
          onChange={(event) => setDraft(event.target.value.slice(0, BOM_DESCRIPTION_MAX_LENGTH))}
        />
        <p className={styles.counter}>
          {t('common.charactersLimit', {
            counter: normalizedDraft.length,
            limit: BOM_DESCRIPTION_MAX_LENGTH,
          })}
        </p>
        <div className={styles.footer}>
          <Button
            title={t('common.cancel')}
            variant={BUTTON_VARIANT.cancel}
            className={styles.footerButton}
            onClick={onClose}
          />
          <Button
            title={t('common.save')}
            variant={BUTTON_VARIANT.primary}
            className={styles.footerButton}
            onClick={() => onSave(normalizedDraft)}
          />
        </div>
      </div>
    </div>,
    document.body,
  );
}

export default BomDescriptionModal;
